import * as yup from 'yup';

import { LocationDto } from '@/lib/locations/dto';
import { PHONE_REGEXP } from '@/utils/constants';

export enum MeetingEventSpaceInquiryFormSteps {
  Application = 'application',
  Success = 'success',
}

export enum DateFlexibility {
  Exact = 'exact',
  OneToTwoDays = 'oneToTwoDays',
  ThreeToFourDays = 'threeToFourDays',
  Flexible = 'flexible',
}

export const meetingEventSpaceInquiryFormSchema = yup
  .object({
    firstName: yup.string().trim().required('firstname-required'),
    lastName: yup.string().trim().required('lastname-required'),
    email: yup
      .string()
      .trim()
      .required('email-required')
      .email('email-invalid'),
    telephone: yup
      .string()
      .trim()
      .required('telephone-required')
      .matches(PHONE_REGEXP, 'telephone-invalid'),
    company: yup.string().trim().required('company-required'),
    numberAttendees: yup
      .number()
      .typeError('numberAttendees-required')
      .required('numberAttendees-required'),
    date: yup.string().required('date-required'),
    startTime: yup.string().required('startTime-required'),
    endTime: yup.string().required('endTime-required'),
    dateFlexibility: yup.string().required('dateFlexibility-required'),
    location: yup.string().required('location-required'),
    openToNearbyLocations: yup.boolean(),
    eventDescription: yup.string(),
  })
  .required();

export type MeetingEventSpaceInquiryFormData = yup.InferType<
  typeof meetingEventSpaceInquiryFormSchema
>;

export type LocationOption = Pick<
  LocationDto,
  'sfId' | 'name' | 'city' | 'metroName'
>;
export type LocationForForm = Pick<
  LocationDto,
  'sfId' | 'name' | 'city' | 'phase' | 'phone' | 'country' | 'metroName'
>;
